import { createSlice, createAsyncThunk} from "@reduxjs/toolkit";
import { PermissionsList } from "models/dbModels/permissions/PermissionsList";
import { noAccess } from "constants/menu";
import { UsersApi } from "apis/UsersApi";

interface state {
    id: number;
    email: string;
    givenName: string;
    familyName: string;
    permissions: PermissionsList
}

const initialState : state = {
    id: 0,
    email: "",
    givenName: "",
    familyName: "",
    permissions: {
        dashboard: noAccess,
        managedStock: noAccess,
        departments: noAccess,
        manufacturers: noAccess,
        suppliers: noAccess,
        stockGroups: noAccess,
        priceGroups: noAccess,
        assignPriceGroups: noAccess,
        dispensePricing: noAccess,
        promotions: noAccess,
        preferredBrands: noAccess,
        orders: noAccess,
        supplierDeals: noAccess,
        supplierGroupDeals: noAccess,
        reports: noAccess,
        stores: noAccess,
        accounts: noAccess,
        storeGroups: noAccess,
        lockDownFields: noAccess,
        permissions: noAccess,
        functions: noAccess,
        managedStockPdes : noAccess,
    },
}

function parseJwt (token:any) {
    if (token) {
        const base64Url = token.split(".")[1];
        const base64 = base64Url.replace(/-/g, "+").replace(/_/g, "/");
        const jsonPayload = decodeURIComponent(window.atob(base64).split("").map(function(c) {
            return "%" + ("00" + c.charCodeAt(0).toString(16)).slice(-2);
        }).join(""));
        return JSON.parse(jsonPayload);
    } else {
        return null;
    }
}


declare const heap: any;
export const getUserDetails = createAsyncThunk("userSlice/getUserDetails", async () => {
    const response = await UsersApi.CurrentUser();
    return response.data;
});

const userSlice = createSlice({
    name: "userSlice",
    initialState: initialState, 
    reducers: {
        getUser: (state) => {
            const tokenData = parseJwt(localStorage.getItem("authData")?? null);
            if (tokenData) {
                state.id = tokenData.UserId;
                state.email = tokenData.Email;
                state.givenName = tokenData.GivenName;
                state.familyName = tokenData.FamilyName;
            } 
        },
        fakePermissionUpdate: (state, action) => {
            //@ts-ignore
            state.permissions[action.payload.model][action.payload.permission] = action.payload.value;
            return state;
        },
    },
    extraReducers: (builder) => {
        builder.addCase(getUserDetails.fulfilled, (state, action) => {
            state.permissions = action.payload.data?.permissions ?? initialState.permissions;
        });
    }
});

export const { getUser } = userSlice.actions;

export default userSlice.reducer;